<template>
  <b-modal id="refund-confirm-modal"
           ref="refund-confirm-modal"
           :hide-header-close="true"
           headerClass="border-0 text-center"
           bodyClass="py-3"
           footerClass="modal-footer border-top-0"
           centered>
    <template v-slot:modal-header>
      <h3 class="mx-auto mb-0">{{ $t('flexben.requests.modal.confirm_refund_title') }}</h3>
    </template>

    <template v-slot:default>
      <p class="mb-0">{{ confirmMessage }}</p>
    </template>

    <template v-slot:modal-footer>
      <button class="btn text-themed mr-auto"
              :disabled="processing"
              @click="closeModal()">
        {{ $t('flexben.general.btn.close') }}
      </button>
      <button class="btn btn-themed"
              :disabled="processing"
              @click="confirmRefund()">
        {{ $t('flexben.general.btn.confirm') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import {BModal} from "bootstrap-vue";

export default {
  name: "RefundConfirmModal",
  components: {
    'b-modal': BModal
  },
  props: {
    processing: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      requestId: null,
      confirmMessage: ''
    };
  },
  methods: {
    openModal(requestId, confirmMessage) {
      this.requestId = requestId;
      this.confirmMessage = confirmMessage || this.$t('flexben.requests.modal.confirm_refund_message');
      this.$refs['refund-confirm-modal'].show();
    },
    closeModal(force = false) {
      if (this.processing && !force) {
        return;
      }
      this.requestId = null;
      this.confirmMessage = '';
      this.$refs['refund-confirm-modal'].hide();
    },
    confirmRefund() {
      if (this.processing || !this.requestId) {
        return;
      }
      this.$emit('confirmRefund', this.requestId);
    }
  }
}
</script>
